<script>
    import HubChatPicker from "./hub/HubChatPicker.svelte";
    import { messaging } from "./store/messaging-store";
    import { onMount } from "svelte";
    import { PRConnect } from "@projectroom/ui-lib";
    import axios from "axios";
    import ContentsBlockButton from "./../components/ContentsBlockButton.svelte";
    import { Section, Input, Textarea } from "../lib/ui";

    export let bot;

    const LAYOUT_TYPES = [
        { type: "TYPE_A", label: "아바타형" },
        { type: "TYPE_B", label: "미니멀" },
        { type: "TYPE_C", label: "커버형" },
        { type: "TYPE_D", label: "배경형" },
    ];

    let addLogoImageRef;
    let addCoverImageRef;

    onMount(() => {
        let savedScrollTop = 0;
        const getScrollContainer = () =>
            document.querySelector(".builder-editor-scroll");

        jQuery(".contents-block-ul").sortable({
            scroll: false,
            helper: "clone",
            forcePlaceholderSize: true,
            start: function (_event, ui) {
                ui.helper.css("height", ui.item.outerHeight());
                ui.item.find(":focus").blur();
                if (document.activeElement) document.activeElement.blur();
                const container = getScrollContainer();
                if (container) savedScrollTop = container.scrollTop;
            },
            stop: function (_event, _ui) {
                document
                    .querySelectorAll(".contents-block-li")
                    .forEach((e, idx) => {
                        const id = e.dataset.id;
                        bot.defaultChar.changeFixedButtonSeq(id, idx);
                    });
                const container = getScrollContainer();
                if (container) {
                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            container.scrollTop = savedScrollTop;
                        });
                    });
                }
            },
        });
    });

    const onLogoImageSelected = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const key = `${bot.id}/common/logo-image/${file.name}`;
        const type = file.type;
        PRConnect.send(
            "/api/File/uploadPresignedUrl",
            { key, type },
            (data) => {
                axios
                    .put(data.result, file, {
                        headers: { "Content-Type": type },
                    })
                    .then(() => {
                        bot.changeLogoImageContent(file.name);
                        addLogoImageRef.value = null;
                    });
            },
        );
    };

    const clickLogoImageDelete = () => {
        bot.changeLogoImageContent(null);
    };

    const onCoverImageSelected = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const key = `${bot.id}/common/cover-image/${file.name}`;
        const type = file.type;
        PRConnect.send(
            "/api/File/uploadPresignedUrl",
            { key, type },
            (data) => {
                axios
                    .put(data.result, file, {
                        headers: { "Content-Type": type },
                    })
                    .then(() => {
                        bot.changeCoverImageContent(file.name);
                        addCoverImageRef.value = null;
                    });
            },
        );
    };

    const clickCoverImageDelete = () => {
        bot.changeCoverImageContent(null);
    };

    // 추가 가능한 콘텐츠(블록) 타입. auth가 있으면 플랜 권한이 필요(자물쇠 표시).
    // ChatBuilder V3의 '콘텐츠 추가'와 같은 단위 + 봇 빌더처럼 아이콘 카드로 표시.
    const BLOCK_TYPES = [
        {
            type: "LINK",
            label: "링크",
            icon: "/static/images/link-btn-icon.svg",
        },
        // { type: "SCENARIO", label: "섹션연결", icon: "/static/images/talk-icon.svg", auth: "SCENARIO" },
        {
            type: "IFRAME",
            label: "유튜브",
            icon: "/static/images/youtube-btn-icon.svg",
            auth: "IFRAME",
        },
        {
            type: "TEXT",
            label: "텍스트",
            icon: "/static/images/text-btn-icon.svg",
            auth: "TEXT",
        },
        {
            type: "PRIVACY",
            label: "개인정보 입력폼",
            icon: "/static/images/form-btn-icon.svg",
            auth: "PRIVACY",
        },
        {
            type: "DIVIDE",
            label: "간격조절",
            icon: "/static/images/link-btn-icon.svg",
            auth: "DIVIDE",
        },
    ];

    // 팔레트에서 타입을 고르면 그 타입의 블록을 바로 추가(2단계 → 1단계).
    const addBlock = (t) => {
        if (t.auth && !bot.isAuthority("buttonType", t.auth)) return;
        bot.defaultChar.addContentBlock(t.type);
        setTimeout(() => {
            const items = document.querySelectorAll(".contents-block-li");
            items[items.length - 1]?.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }, 150);
    };
</script>

<div
    class="tw-font-sans tw-text-foreground"
    class:tw-hidden={bot.currentTab !== "contents"}
>
    <!-- 허브페이지의 '콘텐츠'는 링크·텍스트 블록이 아니라 **격자에 담을 채팅**이다.
         같은 탭 자리를 쓰되 내용만 갈아끼운다 — 디자인·이미지에셋·통계·설정 같은
         공통 탭은 그대로 딸려와야 하므로 빌더를 따로 파지 않는다. -->
    {#if bot.isHub}
        <HubChatPicker botId={bot.id} {bot} on:saved={() => messaging.set({ target: "Preview", action: "refreshPreview" })} />
    {:else}
    <div class="tw-space-y-4">
        {#if bot.isEnterprise}
            <!-- ── 프로필 ── -->
            <Section title="프로필">
                <div class="tw-space-y-5">
                    <!-- 레이아웃 -->
                    <div>
                        <div
                            class="tw-mb-2 tw-text-xs tw-font-medium tw-text-muted-foreground"
                        >
                            레이아웃
                        </div>
                        <div class="layout-grid">
                            {#each LAYOUT_TYPES as layout}
                                <button
                                    type="button"
                                    class="layout-card"
                                    class:layout-card--active={bot.enterpriseLayoutType ===
                                        layout.type}
                                    on:click={(e) => {
                                        e.currentTarget.blur();
                                        bot.changeEnterpriseLayoutType(
                                            layout.type,
                                        );
                                    }}
                                >
                                    <div
                                        class="layout-thumb layout-thumb--{layout.type}"
                                    ></div>
                                    <span class="layout-label"
                                        >{layout.label}</span
                                    >
                                </button>
                            {/each}
                        </div>
                    </div>

                    <!-- 커버 이미지 (TYPE_C 전용) -->
                    {#if bot.enterpriseLayoutType === "TYPE_C"}
                        <div>
                            <div
                                class="tw-mb-2 tw-text-xs tw-font-medium tw-text-muted-foreground"
                            >
                                커버 이미지
                            </div>
                            <div
                                class="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-border-border tw-bg-muted/40 tw-p-4"
                            >
                                {#if bot.coverImageContent}
                                    <div class="tw-relative tw-inline-block">
                                        <img
                                            src={bot.getCoverImageContent()}
                                            loading="lazy"
                                            alt=""
                                            class="tw-max-h-36 tw-rounded-md"
                                        />
                                        <button
                                            type="button"
                                            class="tw-absolute tw-right-1 tw-top-1 tw-inline-flex tw-h-6 tw-w-6 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-bg-black/50 tw-text-white hover:tw-bg-black/70"
                                            on:click={clickCoverImageDelete}
                                            aria-label="삭제"
                                        >
                                            <svg
                                                class="tw-h-3.5 tw-w-3.5"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                ><path
                                                    d="M18 6 6 18M6 6l12 12"
                                                /></svg
                                            >
                                        </button>
                                    </div>
                                {:else}
                                    <img
                                        src="/static/images/upload-icon-big.svg"
                                        loading="lazy"
                                        alt=""
                                        class="tw-h-10 tw-w-10 tw-opacity-70"
                                    />
                                {/if}
                                <input
                                    type="file"
                                    accept="image/*"
                                    bind:this={addCoverImageRef}
                                    on:change={onCoverImageSelected}
                                    hidden
                                    tabindex="-1"
                                />
                                <button
                                    type="button"
                                    class="tw-inline-flex tw-h-9 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-4 tw-text-sm tw-font-medium tw-text-foreground tw-transition-colors hover:tw-bg-muted"
                                    on:click={(e) => {
                                        e.currentTarget.blur();
                                        addCoverImageRef.click();
                                    }}
                                    >{bot.backImageContent
                                        ? "이미지 변경"
                                        : "이미지 업로드"}</button
                                >
                            </div>
                        </div>
                    {/if}

                    <!-- 프로필/이미지 -->
                    <div>
                        <div
                            class="tw-mb-2 tw-text-xs tw-font-medium tw-text-muted-foreground"
                        >
                            {bot.enterpriseLayoutType === "TYPE_C"
                                ? "프로필 이미지"
                                : "이미지"}
                        </div>
                        <div
                            class="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-border-border tw-bg-muted/40 tw-p-4"
                        >
                            {#if bot.logoImageContent}
                                <div class="tw-relative tw-inline-block">
                                    <img
                                        src={bot.getLogoImageContent()}
                                        loading="lazy"
                                        alt=""
                                        class="tw-max-h-36 tw-rounded-md"
                                    />
                                    <button
                                        type="button"
                                        class="tw-absolute tw-right-1 tw-top-1 tw-inline-flex tw-h-6 tw-w-6 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-bg-black/50 tw-text-white hover:tw-bg-black/70"
                                        on:click={clickLogoImageDelete}
                                        aria-label="삭제"
                                    >
                                        <svg
                                            class="tw-h-3.5 tw-w-3.5"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            ><path
                                                d="M18 6 6 18M6 6l12 12"
                                            /></svg
                                        >
                                    </button>
                                </div>
                            {:else}
                                <img
                                    src="/static/images/upload-icon-big.svg"
                                    loading="lazy"
                                    alt=""
                                    class="tw-h-10 tw-w-10 tw-opacity-70"
                                />
                            {/if}
                            <input
                                type="file"
                                accept="image/*"
                                bind:this={addLogoImageRef}
                                on:change={onLogoImageSelected}
                                hidden
                                tabindex="-1"
                            />
                            <button
                                type="button"
                                class="tw-inline-flex tw-h-9 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-4 tw-text-sm tw-font-medium tw-text-foreground tw-transition-colors hover:tw-bg-muted"
                                on:click={(e) => {
                                    e.currentTarget.blur();
                                    addLogoImageRef.click();
                                }}
                                >{bot.logoImageContent
                                    ? "이미지 변경"
                                    : "이미지 업로드"}</button
                            >
                        </div>
                    </div>

                    <!-- 대표문구 -->
                    <div>
                        <div
                            class="tw-text-xs tw-font-medium tw-text-foreground"
                        >
                            대표문구
                        </div>
                        <div
                            class="tw-mb-2 tw-mt-0.5 tw-text-[11px] tw-text-muted-foreground"
                        >
                            대표 이름 또는 브랜드명
                        </div>
                        <Input
                            type="text"
                            placeholder="예) 홍길동, 아바톡 브랜드"
                            value={bot.title ?? ""}
                            on:change={(e) =>
                                bot.changeBotTitle(e.target.value)}
                        />
                    </div>

                    <!-- 상세문구 -->
                    <div>
                        <div
                            class="tw-text-xs tw-font-medium tw-text-foreground"
                        >
                            상세문구
                        </div>
                        <div
                            class="tw-mb-2 tw-mt-0.5 tw-text-[11px] tw-text-muted-foreground"
                        >
                            프로필 소개 또는 한 줄 설명
                        </div>
                        <Textarea
                            rows="3"
                            placeholder="예) 안녕하세요! 저는 아바톡을 운영하고 있습니다."
                            value={bot.subTitle ?? ""}
                            on:change={(e) =>
                                bot.changeBotSubTitle(e.target.value)}
                        />
                    </div>
                </div>
            </Section>
        {/if}

        <!-- ── 콘텐츠(링크) 블록 목록 ── -->
        <Section
            title={bot.isEnterprise
                ? "링크 버튼"
                : "캐릭터와 관련된 콘텐츠를 연결해보세요!"}
        >
            <!-- 블록 추가: ChatBuilder V3 '콘텐츠 추가'와 같은 단위. 봇 빌더처럼 아이콘 카드로.
                 타입을 누르면 그 타입 블록이 바로 추가됨(팔레트 상시 노출). -->
            <div class="block-add-zone tw-mb-4" data-step="4">
                <div class="block-add-label">블록 추가</div>
                <div class="block-add-grid">
                    {#each BLOCK_TYPES as t (t.type)}
                        <button
                            type="button"
                            class="block-add-card"
                            class:locked={t.auth &&
                                !bot.isAvailableType("buttonType", t.auth)}
                            on:click|preventDefault={() => addBlock(t)}
                        >
                            <img src={t.icon} alt="" class="block-add-icon" />
                            <span class="block-add-name">{t.label}</span>
                            {#if t.auth && !bot.isAvailableType("buttonType", t.auth)}
                                <img
                                    src="/static/images/lock.svg"
                                    alt=""
                                    class="block-add-lock"
                                />
                            {/if}
                        </button>
                    {/each}
                </div>
            </div>
            <ul class="contents-block-ul tw-space-y-3">
                {#each bot.defaultChar.fixedButtonList as button (button.id)}
                    <li class="contents-block-li" data-id={button.id}>
                        <ContentsBlockButton {bot} {button} />
                    </li>
                {/each}
            </ul>
        </Section>
    </div>
    {/if}
</div>

<style>
    /* 콘텐츠(고정) 블록 리스트: jQuery sortable 대상 */
    .contents-block-ul {
        list-style-type: none;
        padding-left: 0px;
    }

    /* 블록 추가 존 — ChatBuilder V3 '콘텐츠 추가'(block-add-zone)와 동일 스타일 */
    .block-add-zone {
        padding: 12px;
        border: 1px solid hsl(var(--sb-primary) / 0.5);
        border-radius: 10px;
        background: hsl(var(--sb-muted) / 0.4);
    }
    .block-add-label {
        font-size: 11px;
        font-weight: 600;
        color: hsl(var(--sb-primary));
        margin-bottom: 8px;
        padding-left: 2px;
    }
    /* 봇 빌더처럼 아이콘 카드 그리드 */
    .block-add-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
    }
    .block-add-card {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 12px 6px;
        /* 기본에서도 카드가 존(zone)과 구분되게 옅은 primary 틴트 테두리(다크모드 대비) */
        border: 1px solid hsl(var(--sb-primary) / 0.2);
        border-radius: 8px;
        background: hsl(var(--sb-card));
        cursor: pointer;
        transition:
            border-color 0.15s,
            background 0.15s;
    }
    /* 호버: 은은한 primary 틴트 + primary 테두리 → 다크모드에서도 카드 윤곽이 보이게 */
    .block-add-card:hover {
        border-color: hsl(var(--sb-primary));
        background: hsl(var(--sb-primary) / 0.1);
    }
    .block-add-card.locked {
        opacity: 0.6;
    }
    .block-add-icon {
        width: 24px;
        height: 24px;
    }
    .block-add-name {
        font-size: 12px;
        font-weight: 500;
        color: hsl(var(--sb-foreground));
        white-space: nowrap;
    }
    .block-add-lock {
        position: absolute;
        top: 5px;
        right: 5px;
        width: 14px;
        height: 14px;
    }

    /* 엔터프라이즈 레이아웃 4종 미니 미리보기(전용 CSS 아트) — 유지 */
    .layout-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 8px;
        margin-top: 8px;
    }

    .layout-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
        padding: 6px;
        border: 2px solid #e8e8e8;
        border-radius: 8px;
        background: #fff;
        cursor: pointer;
        transition: border-color 0.15s;
    }
    .layout-card--active {
        border-color: #111;
    }

    .layout-thumb {
        width: 100%;
        aspect-ratio: 9 / 16;
        border-radius: 4px;
        background: #f0f0f0;
        position: relative;
        overflow: hidden;
    }

    /*
     * 썸네일 구조 (9:16 = 풀 페이지 비율)
     *   커버 영역 (gray) + 아바타 원형 + 대표문구/상세문구 + 링크버튼 3개
     *
     * ::after height 11px = [대표문구 4px] [gap 3px] [상세문구 4px]
     *   background 이중레이어: 대표문구 100% 폭, 상세문구 72% 폭 (더 짧게)
     *   box-shadow: 링크버튼 3개 (gray #ddd, height 11px 동일)
     */

    /* ── TYPE_A: 커버 1/3 ── */
    .layout-thumb--TYPE_A {
        background: linear-gradient(
            to bottom,
            #c8c8c8 33%,
            transparent 43%,
            #fff 43%
        );
    }
    .layout-thumb--TYPE_A::before {
        content: "";
        position: absolute;
        top: 12%;
        left: 50%;
        transform: translateX(-50%);
        width: 26%;
        aspect-ratio: 1;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.75);
        border: 2px solid white;
    }
    .layout-thumb--TYPE_A::after {
        content: "";
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translateX(-50%);
        width: 52%;
        height: 11px;
        background:
            linear-gradient(#888, #888) no-repeat center 0 / 84% 4px,
            linear-gradient(#c0c0c0, #c0c0c0) no-repeat center 100% / 60% 4px;
        border-radius: 2px;
    }

    /* ── TYPE_B: 미니멀 ── */
    .layout-thumb--TYPE_B {
        background: #fff;
        box-shadow: inset 0 0 0 1px #ebebeb;
    }
    .layout-thumb--TYPE_B::before {
        content: "";
        position: absolute;
        top: 8%;
        left: 50%;
        transform: translateX(-50%);
        width: 26%;
        aspect-ratio: 1;
        border-radius: 50%;
        background: #ccc;
    }
    .layout-thumb--TYPE_B::after {
        content: "";
        position: absolute;
        top: 28%;
        left: 50%;
        transform: translateX(-50%);
        width: 52%;
        height: 11px;
        background:
            linear-gradient(#888, #888) no-repeat center 0 / 84% 4px,
            linear-gradient(#c0c0c0, #c0c0c0) no-repeat center 100% / 60% 4px;
        border-radius: 2px;
    }

    /* ── TYPE_C: 커버 1/3 + 아바타 겹침 ── */
    .layout-thumb--TYPE_C {
        background: linear-gradient(
            to bottom,
            #c8c8c8 35%,
            transparent 35%,
            #fff 43%
        );
    }
    .layout-thumb--TYPE_C::before {
        content: "";
        position: absolute;
        top: 26%;
        left: 50%;
        transform: translateX(-50%);
        width: 26%;
        aspect-ratio: 1;
        border-radius: 50%;
        background: #e0e0e0;
        border: 2px solid #fff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
    }
    .layout-thumb--TYPE_C::after {
        content: "";
        position: absolute;
        top: 44%;
        left: 50%;
        transform: translateX(-50%);
        width: 52%;
        height: 11px;
        background:
            linear-gradient(#888, #888) no-repeat center 0 / 84% 4px,
            linear-gradient(#c0c0c0, #c0c0c0) no-repeat center 100% / 60% 4px;
        border-radius: 2px;
    }

    /* ── TYPE_D: 커버 1/4 ── */
    .layout-thumb--TYPE_D {
        background: linear-gradient(
            to bottom,
            #c8c8c8 35%,
            transparent 35%,
            #fff 35%
        );
    }
    .layout-thumb--TYPE_D::before {
        content: "";
        position: absolute;
        top: 12%;
        left: 50%;
        transform: translateX(-50%);
        width: 26%;
        aspect-ratio: 1;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.75);
    }
    .layout-thumb--TYPE_D::after {
        content: "";
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translateX(-50%);
        width: 52%;
        height: 11px;
        background:
            linear-gradient(#888, #888) no-repeat center 0 / 84% 4px,
            linear-gradient(#c0c0c0, #c0c0c0) no-repeat center 100% / 60% 4px;
        border-radius: 2px;
    }

    .layout-label {
        font-size: 10px;
        color: #555;
        white-space: nowrap;
    }
</style>
